import {useEffect} from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';

import {Layout} from 'antd';

import {faBars} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import {LOGO_SCOPES} from '@components/Organizations/ClientLogoField/constants';
import {ORGANIZATION_CONFIGURATION_TYPES} from '@containers/Organizations/OrganizationProfilePage/tabs/OrganizationClientConfiguration/ClientConfiguration.constants';

import useCurrentClientLogos from '@hooks/reduxSession/useCurrentClientLogos';
import {getOrgClientLogo} from '@redux/modules/session/actions';

import HeaderLogo from './HeaderLogo';

import './HeaderBar.css';

/**
 * Base app header bar.
 * Add additional contents as children
 */
export default function HeaderBar(props) {
  const {children, className, onToggle, isMobile} = props;

  const dispatch = useDispatch();

  const {getLogoUrl} = useCurrentClientLogos();

  const orgId = useSelector((state) => state.session.currentPermissions.orgId);

  useEffect(() => {
    if (orgId) {
      dispatch(getOrgClientLogo(orgId, ORGANIZATION_CONFIGURATION_TYPES.CUSTOM_LOGO));
    }
  }, [orgId, dispatch]);

  const clientLogoUrl = getLogoUrl(LOGO_SCOPES.WEB_APP);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onToggle(e);
    }
  };

  return (
    <Layout.Header className={classNames('HeaderBar', {mobile: isMobile}, className)}>
      <div className={'logo-wrapper'}>
        {isMobile && (
          <div className="menu-btn header-btn" onClick={onToggle} role="button" tabIndex={0} onKeyDown={handleKeyDown}>
            <FontAwesomeIcon icon={faBars} aria-label={'mobile-menu'} size="lg" />
          </div>
        )}

        <HeaderLogo clientLogoUrl={clientLogoUrl} />

        {children}
      </div>
    </Layout.Header>
  );
}

HeaderBar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  isMobile: PropTypes.bool,
  onToggle: PropTypes.func,
};
